import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  absoluteUrl,
  getSeoMeta,
} from "../config/seo.js";

function upsertHeadElement(selector, createElement, apply) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = createElement();
    document.head.appendChild(element);
  }
  apply(element);
}

function setMetaByName(name, content) {
  upsertHeadElement(
    `meta[name="${name}"]`,
    () => {
      const el = document.createElement("meta");
      el.setAttribute("name", name);
      return el;
    },
    (el) => el.setAttribute("content", content),
  );
}

function setMetaByProperty(property, content) {
  upsertHeadElement(
    `meta[property="${property}"]`,
    () => {
      const el = document.createElement("meta");
      el.setAttribute("property", property);
      return el;
    },
    (el) => el.setAttribute("content", content),
  );
}

function setLink(rel, href) {
  upsertHeadElement(
    `link[rel="${rel}"]`,
    () => {
      const el = document.createElement("link");
      el.setAttribute("rel", rel);
      return el;
    },
    (el) => el.setAttribute("href", href),
  );
}

export function useSeoMetadata() {
  const location = useLocation();

  useEffect(() => {
    const meta = getSeoMeta(location.pathname);
    const canonical = absoluteUrl(meta.path);
    const ogImage = absoluteUrl(meta.image ?? DEFAULT_OG_IMAGE);
    const robots = meta.noindex ? "noindex, nofollow" : "index, follow";

    document.title = meta.title;
    setMetaByName("description", meta.description);
    setMetaByName("robots", robots);
    setLink("canonical", canonical);

    setMetaByProperty("og:site_name", SITE_NAME);
    setMetaByProperty("og:type", "website");
    setMetaByProperty("og:title", meta.title);
    setMetaByProperty("og:description", meta.description);
    setMetaByProperty("og:url", canonical);
    setMetaByProperty("og:image", ogImage);

    setMetaByName("twitter:card", "summary_large_image");
    setMetaByName("twitter:title", meta.title);
    setMetaByName("twitter:description", meta.description);
    setMetaByName("twitter:image", ogImage);
  }, [location.pathname]);
}
